import { ADOBE_MARKETING_CLOUD_ORGANIZATION_ID } from '../../constants/analytics'

export const mapAdobeCookie = () => {
  try {
    if (window.Visitor) {
      return {
        adobeId: window.Visitor.getInstance(
          ADOBE_MARKETING_CLOUD_ORGANIZATION_ID
        ).getMarketingCloudVisitorID(),
      }
    }
    return {}
  } catch (e) {
    return {}
  }
}
